import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50" role="banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <div className="flex items-center">
              {/* <div className="text-2xl font-bold text-blue-400">KEOPS</div> */}
              <img
                src="/logo192.png"
                alt="KEOPS - Fund Risk Reporting Solutions Logo"
                className="h-8 w-auto"
                width="32"
                height="32"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" role="navigation" aria-label="Main navigation">
            <a
              href="#why-keops"
              className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
              aria-label="Learn why choose Keops"
            >
              Why Keops
            </a>
            <a
              href="#product-coverage"
              className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
              aria-label="View our product coverage"
            >
              Coverage
            </a>
            <a
              href="#solutions"
              className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
              aria-label="Explore our solutions"
            >
              Solutions
            </a>
            <a
              href="#contact"
              className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
              aria-label="Contact us"
            >
              Contact
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a
              href="https://platform.keops.lu/login"
              target="_blank"
              className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
            >
              Platform
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-blue-900 hover:text-blue-400 focus:outline-none focus:text-blue-400 transition-colors duration-300"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg rounded-lg mt-2">
              <a
                href="#why-keops"
                className="block px-3 py-2 text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
                onClick={toggleMenu}
              >
                Why Keops
              </a>
              <a
                href="#product-coverage"
                className="block px-3 py-2 text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
                onClick={toggleMenu}
              >
                Coverage
              </a>
              <a
                href="#solutions"
                className="block px-3 py-2 text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
                onClick={toggleMenu}
              >
                Solutions
              </a>
              <a
                href="#contact"
                className="block px-3 py-2 text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
                onClick={toggleMenu}
              >
                Contact
              </a>
              <div className="px-3 py-2">
                <a
                  href="https://platform.keops.lu/login"
                  target="_blank"
                  className="text-blue-900 hover:text-blue-400 font-medium transition-colors duration-300"
                >
                  Platform
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
